<template>
  <div class="container">
    <div class="q-mt-xl">
      <div class="q-my-lg">
        <div>
          <p></p>
          <q-btn
            label="Criar Nova"
            no-caps
            icon="add"
            class="btn"
            color="positive"
            @click="rightDrawerOpen = true"
          />
        </div>
      </div>
      <div class="q-mt-xl">
        <div class="row col-12 justify-between items-center q-mb-sm">
          <div class="q-ml-md text-brand-5 text-weight-bold titulo-tabela">
            Operações Criadas
          </div>
          <div class="row col-md-3 col-xs-12 justify-end">
            <q-input
              rounded
              outlined
              dense
              debounce="300"
              type="text"
              class="col-md col-xs-7 input"
              placeholder="Pesquisar"
              v-model="filtros.nome"
            >
              <template v-slot:append>
                <q-icon name="search" />
              </template>
            </q-input>
          </div>
        </div>
        <q-linear-progress v-if="loading" indeterminate size="3px" />
        <q-table
          :columns="columns"
          :rows="listaOperacao"
          :hide-bottom="!listaOperacao.length == 0"
          no-data-label="Nenhuma operação criada."
          class="my-sticky-dynamic"
          dense
          flat
          :grid="mobile"
          :rows-per-page-options="[0]"
          selection="single"
          row-key="id"
          v-model:selected="selected"
        >
          <template v-slot:item="props">
            <div class="q-pa-xs row col-12">
              <q-card class="container-grid-table col-12">
                <div class="q-pa-sm">
                  <div class="row col-12 items-center">
                    <div class="col">
                      <div class="row col-12 items-center">
                        <strong class="q-mr-xs">Operação:</strong>
                        <span v-if="!props.selected">
                          {{ props.row.nome }}</span
                        >
                        <input
                          v-else
                          v-model="props.row.nome"
                          dense
                          class="input-mobile"
                          outlined
                        />
                      </div>
                    </div>
                    <div class="col">
                      <div class="row col-12 justify-end">
                        <div>
                          <q-btn
                            icon="delete"
                            flat
                            color="red"
                            @click="
                              excluirOperacao(
                                props.row.transferenciaOperacaoUuid
                              )
                            "
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </q-card>
            </div>
          </template>
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th
                class="text-weight-bolder"
                v-for="col in props.cols"
                :key="col.name"
                :props="props"
              >
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr class="text-brand-5 text-weight-bold">
              <q-td>{{ props.row.nome }}</q-td>
              <q-td class="coluna-btn">
                <q-btn
                  icon="delete"
                  flat
                  round
                  color="red"
                  :disable="disable"
                  @click="excluirOperacao(props.row.transferenciaOperacaoUuid)"
                />
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </div>
      <Transition name="slide-fade">
        <q-card v-if="rightDrawerOpen" class="drawer-modal">
          <div class="row q-pa-md text-weight-bold">
            <div class="row col-12 items-center">
              <q-icon
                style="cursor: pointer"
                name="close"
                class="q-mr-md"
                size="22px"
                @click="rightDrawerOpen = false"
              />
              <span class="texto-titulo-modal"> Criar Operação </span>
            </div>
          </div>
          <div style="width: 100%; height: 89%">
            <div class="column col-12 justify-between no-wrap container-modal">
              <div class="q-px-md text-weight-bold">
                <div>
                  <div class="texto-titulo-input">Nome</div>
                  <q-input
                    v-model="dado.nome"
                    class="input-modal"
                    dense
                    outlined
                  />
                </div>
              </div>
              <div class="q-my-sm q-px-md">
                <q-btn
                  label="Criar"
                  color="positive"
                  no-caps
                  icon="done"
                  @click="criarOperacao()"
                />
              </div>
            </div>
          </div>
        </q-card>
      </Transition>
    </div>
    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>
  </div>
</template>

<script>
import { useQuasar } from "quasar";
import { onMounted, ref, computed, watch } from "vue";
import { useStore } from "vuex";
import { salvarCatalogoUuid } from "../composables/salvarCatalogoUuid";

const columns = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "excluir",
    label: "Excluir",
    align: "left",
  },
];

export default {
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    let rightDrawerOpen = ref(false);
    const catalogoUuid = salvarCatalogoUuid();
    const listaOperacao = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    let loading = ref(false);
    const dadoEditar = ref({});
    const selected = ref([]);
    const dado = ref({ nome: "" });
    const filtros = ref({ nome: "" });
    let disable = ref(false);
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const listarOperacao = async () => {
      disable.value = true;
      loading.value = true;
      if (catalogoUuid.catalogoUuid.value == null) {
        listaOperacao.value = [];
        return;
      }
      try {
        const response = await store.dispatch("ferramentaria/listarOperacao", {
          catalogoUuid: catalogoUuid.catalogoUuid.value,
          nome: filtros.value.nome,
        });
        listaOperacao.value = response.data.resultado.dados;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        loading.value = false;
        disable.value = false;
        console.log(error);
      }
    };

    const excluirOperacao = async (transferenciaOperacaoUuid) => {
      try {
        await store.dispatch("ferramentaria/excluirOperacao", {
          transferenciaOperacaoUuid: transferenciaOperacaoUuid,
          catalogoUuid: catalogoUuid.catalogoUuid.value,
        });
        quasar.notify({
          message: "Operação excluída com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarOperacao();
      } catch (error) {
        quasar.notify({
          message: "Erro ao excluir operação.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const criarOperacao = async () => {
      try {
        await store.dispatch("ferramentaria/adcionarOperacao", {
          catalogoUuid: catalogoUuid.catalogoUuid.value,
          nome: dado.value.nome,
          descricao: dado.value.nome,
        });
        quasar.notify({
          message: "Operação criada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        listarOperacao();
        resetVariavel();
        rightDrawerOpen.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro ao criar operação.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const resetVariavel = () => {
      dado.value = {
        nome: "",
      };
    };

    watch(
      () => catalogoUuid.catalogoUuid.value,
      () => {
        listarOperacao();
      }
    );

    watch(
      () => filtros.value.nome,
      () => {
        listarOperacao();
      }
    );

    onMounted(() => {
      listarOperacao();
    });

    return {
      columns,
      rightDrawerOpen,
      listarOperacao,
      listaOperacao,
      excluirOperacao,
      pagination,
      loading,
      dadoEditar,
      dado,
      disable,
      catalogoUuid,
      filtros,
      resetVariavel,
      criarOperacao,
      selected,
      mobile,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
.container {
  height: 100% !important;
}
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
/* bg color is important for th; just specify one */

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

/* this is when the loading indicator appears */
.q-table--loading thead tr:last-child th {
  top: 48px;
}
.input {
  width: 180px;
}
tbody tr .coluna-btn {
  width: 120px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100% !important;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.container-modal {
  height: 100%;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
.titulo-tabela {
  font-size: 18px;
}
.texto-titulo-modal {
  font-size: 16px;
}
@media (max-width: 1400px) {
  .drawer-modal {
    height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1000px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
@media (max-width: 600px) {
  .drawer-modal {
    max-height: 100%;
    height: 85%;
    overflow: hidden;
    top: 103px;
    width: 340px;
  }
  .btn {
    font-size: 12px;
  }
  .titulo-tabela {
    font-size: 14px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .input-mobile {
    width: 90px;
    outline: none;
  }
  .texto-titulo-modal {
    font-size: 14px;
  }
  .input-modal {
    font-size: 12px;
  }
  .texto-titulo-input {
    font-size: 12px;
  }
}
@media (max-width: 372px) {
  .btn {
    font-size: 11px;
  }
}
</style>
